import { render, staticRenderFns } from "./PackagingDetails_new_daHuo.vue?vue&type=template&id=14d5be99&scoped=true&"
import script from "./PackagingDetails_new_daHuo.vue?vue&type=script&lang=js&"
export * from "./PackagingDetails_new_daHuo.vue?vue&type=script&lang=js&"
import style0 from "./PackagingDetails_new_daHuo.vue?vue&type=style&index=0&id=14d5be99&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14d5be99",
  null
  
)

export default component.exports